// extracted by mini-css-extract-plugin
export var FooterCTA = "FooterCTA-module--FooterCTA--5518f";
export var description = "FooterCTA-module--description--b8146";